import React from "react";
import { Form, Col } from "react-bootstrap";
import CustomReactSelect from "../../../components/CustomReactSelect";
import FilterationBarContainer from "../../../components/FilterationBarContainer";

function FilterationBar(props) {
  const {
    employeeList,
    supervisorList,
    projectList,
    selectedEmployee,
    selectedSupervisor,
    selectedProject,
    onEmployeeChange,
    onSupervisorChange,
    onProjectChange,
  } = props;
  return (
    <FilterationBarContainer>
      <Col lg={4} className="mb-1">
        <Form.Group className="input-field">
          <Form.Label className="label">Employee</Form.Label>
          <Col>
            <CustomReactSelect
              options={employeeList}
              value={selectedEmployee}
              onChange={(value) => onEmployeeChange(value)}
            />
          </Col>
        </Form.Group>
      </Col>
      <Col lg={4} className="mb-1">
        <Form.Group className="input-field">
          <Form.Label className="label">Supervisor</Form.Label>
          <Col>
            <CustomReactSelect
              options={supervisorList}
              value={selectedSupervisor}
              onChange={(value) => onSupervisorChange(value)}
            />
          </Col>
        </Form.Group>
      </Col>
      <Col lg={4}>
        <Form.Group className="input-field">
          <Form.Label className="label">Project</Form.Label>
          <Col>
            <CustomReactSelect
              options={projectList}
              value={selectedProject}
              onChange={(value) => onProjectChange(value)}
            />
          </Col>
        </Form.Group>
      </Col>
    </FilterationBarContainer>
  );
}

export default FilterationBar;
